<template>
  <v-container
      class="fill-height"
      fluid
  >
    <v-row
        align="center"
        justify="center"
    >
      <v-col
          cols="12"
          sm="10"
          md="8"
          lg="6"
          xl="3"
      >
        <v-card class="elevation-12">
          <v-form ref="form" @submit.prevent="login">
            <v-card-text class="py-0">
              <div class="pt-5 mb-10">
                <v-img
                    v-bind:src="require('/src/assets/images/logo.svg')"
                    contain
                    height="124px"
                    position="center center"
                ></v-img>
              </div>
              <div class="text-center">
                <h2>需要予測サービス</h2>
              </div>
              <v-text-field
                  label="企業コード"
                  name="company_code"
                  placeholder="U-XXXX-XXXX"
                  prepend-icon="mdi-office-building"
                  type="text"
                  v-model="loginForm.company_code"
              ></v-text-field>

              <v-text-field
                  label="担当者コード"
                  name="login"
                  placeholder="半角数字8桁"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="loginForm.user_code"
              ></v-text-field>

              <v-text-field
                  label="パスワード"
                  name="password"
                  :append-icon="isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="isShowPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  v-model="loginForm.password"
                  @click:append="isShowPassword = !isShowPassword"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-row
                  class="text-center ma-4"
              >
                <v-col>
                  <v-btn
                      width="80%"
                      type="submit"
                      class="common-save-btn"
                  >ログイン
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-spacer></v-spacer>
      <span class="grey--text">©USEN CORPORATION</span>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>

import {mapGetters} from "vuex";
import {clearData, SAVE_STORE_GRAPH, SAVE_STORE_SUMMARY} from "../../../util";

export default {
  computed: {
    ...mapGetters({
      token: 'auth/token'
    }),
  },
  data() {
    return {
      loginForm: {
        company_code: '',
        user_code: '',
        password: ''
      },
      isShowPassword: false
    }
  },
  async mounted() {
    if (this.token === '') {
      await this.$store.dispatch('auth/loginCheck')
    }
    await this.$store.dispatch('demand/reset')
    await this.clearComparison()
  },
  methods: {
    async login() {
      // authストアのloginアクションを呼び出す
      let isLogin = await this.$store.dispatch('auth/login', this.loginForm)
      if (isLogin) {
        if (this.$route.query.redirect) {
          await this.$router.push(String(this.$route.query.redirect))
        } else {
          // トップページに移動する
          await this.$router.push('/')
        }
      } else {
        await this.$store.dispatch('modal/open', {
          isOpen: true,
          message: 'ログインに失敗しました。',
          title: "エラー"
        })
      }
    },
    clearComparison() {
      clearData(SAVE_STORE_SUMMARY)
      clearData(SAVE_STORE_GRAPH)
      this.$store.dispatch('comparison/reset')
    }
  }
}
</script>